// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__36QdK","fileBtn":"File_fileBtn__37dHJ","closeBtn":"File_closeBtn__q429Q","fileSelected":"File_fileSelected__1dCQY","disabled":"File_disabled__Kl8az"};